import { computed, ref } from 'vue';

import { defineStore } from 'pinia';

import { getItemFromLocalStorage, setItemToLocalStorage } from '@/helpers/localStorageServices';
import { VIEWPORT_TYPES, applyViewportMeta, isDesktopOnlyRoute } from '@/helpers/viewportHelper';

const VIEWPORT_PREFERENCE = 'viewport-preference';

export const useViewportStore = defineStore('viewport', () => {
  // 'desktop' | 'mobile' | null — no explicit choice yet → per-route default (DESKTOP_ONLY_ROUTES).
  const preference = ref(getItemFromLocalStorage(VIEWPORT_PREFERENCE) || null);
  const currentViewport = ref('responsive');
  const lastAppliedPath = ref('/');

  const isDesktopViewport = computed(() => currentViewport.value === 'desktop');

  const resolveViewport = (path) => {
    if (preference.value === 'desktop') return 'desktop';
    if (preference.value === 'mobile') return 'responsive';
    return isDesktopOnlyRoute(path) ? 'desktop' : 'responsive';
  };

  const applyViewport = (path) => {
    lastAppliedPath.value = path;
    currentViewport.value = resolveViewport(path);
    applyViewportMeta(
      isDesktopViewport.value ? VIEWPORT_TYPES.DESKTOP : VIEWPORT_TYPES.RESPONSIVE,
    );
  };

  const setPreference = (value) => {
    preference.value = value;
    setItemToLocalStorage(VIEWPORT_PREFERENCE, value);
    applyViewport(lastAppliedPath.value);
  };

  // getPath is a getter so the orientation listener resolves the CURRENT route, not the mount-time one.
  const initViewport = (getPath) => {
    applyViewport(getPath());
    window.addEventListener('orientationchange', () => {
      setTimeout(() => applyViewport(getPath()), 100);
    });
  };

  return {
    preference,
    isDesktopViewport,
    applyViewport,
    setPreference,
    initViewport,
  };
});
